import { render, staticRenderFns } from "./FooterContact.vue?vue&type=template&id=e0563cfe&scoped=true"
import script from "./FooterContact.vue?vue&type=script&lang=js"
export * from "./FooterContact.vue?vue&type=script&lang=js"
import style0 from "./FooterContact.vue?vue&type=style&index=0&id=e0563cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0563cfe",
  null
  
)

export default component.exports